const initialState = {
    userValue: {
        UserId: '',
        UserName: '',
        Role: '',
        // Role: 'Co',
        RoleId: '',
        RoleAccess: '',
        ApplicationId:'',
        Designation: '',
        WWID: '',
        token: '',

        AllProjectsAccessPageAccess: [],
        UserPageAccess: [],
        ModuleRoleAccessListPageAccess: [],
    },
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USERS':
            return {
                ...state,
                userValue: action.payload,
            };
        case 'LOGOUT':
            return {
                ...state,
                userValue: initialState.userValue,
            };
        default:
            return state;
    }
};

export default userReducer;